// Sem zod nem fio: a declaração dos filtros entra no arquivo da rota (JS inicial).

/** U20-1: o legado mostra a data final no chip e não envia. Liga só depois do ok da CreditAPI. */
export const FUND_LIST_SENDS_FINAL_DATE = false; // U20-1

const CPF_MASK = '000.000.000-00';
const CNPJ_MASK = '00.000.000/0000-00';

/**
 * Máscara progressiva do filtro CPF/CNPJ do legado: CPF até 11 dígitos, CNPJ acima disso ou com
 * letra (U21: o filtro vai com máscara).
 */
export function maskDocumentLikeLegacy(value: string): string {
  const raw = value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  const mask = raw.length > 11 || /[A-Z]/.test(raw) ? CNPJ_MASK : CPF_MASK;
  let out = '';
  let index = 0;
  for (const slot of mask) {
    if (index >= raw.length) break;
    if (slot === '0') {
      out += raw.charAt(index);
      index += 1;
    } else {
      out += slot;
    }
  }
  return out;
}
